import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import TipoArticuloGestion from './view/TipoArticuloGestion'

export const tipoArticuloRoutesMap = {
  gestion: {
    path: '/tipoArticulo/gestion',
    name: 'Tipos de artículo',
    action: 'TIPOS_DE_ARTICULO',
  },
  registro: {
    path: '/tipoArticulo/nuevo',
    name: 'Nuevo tipo articulo',
    action: 'ADMINISTRAR_TIPOS_DE_ARTICULO',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const tipoArticuloRoutes = [
  {
    path: tipoArticuloRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <TipoArticuloGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default tipoArticuloRoutes
